import React from "react";
import { ReactNode } from "react";
import { Text, useTheme } from "@zapier/design-system";
import { css } from "@emotion/core";
import {
  PaymentSourceType,
  PayPalPaymentSource,
} from "@zapier/payment/esm/types";

import PaymentMethodImage from "@zapier/payment/esm/components/PaymentMethodImage";

type ChildrenProps = {
  /** Paypal Payment source details */
  paypal: PayPalPaymentSource["details"];
};

type Props = {
  children?: (a: ChildrenProps, b: boolean) => ReactNode;

  /** Show compact version of info */
  isCompact?: boolean;
} & ChildrenProps;

const detailsCss = {
  marginLeft: 15,
};

const breakWordCss = css`
  word-break: break-all;
`;

const wrapperCss = {
  alignItems: "center",
  display: "flex",
};

const renderDefaultInfo = ({ paypal }: ChildrenProps) => (
  <div css={[detailsCss, breakWordCss]}>
    <Text fontWeight={700} type="smallPrint1">
      {paypal?.email}
    </Text>
  </div>
);

const renderCompactInfo = ({ paypal }: ChildrenProps, isRebrand?: boolean) => (
  // Ensure lengthy email addresses don't break the invoice list grid
  <div css={breakWordCss}>
    <Text type={isRebrand ? "paragraph3" : "smallPrint1"}>{paypal?.email}</Text>
  </div>
);

const PaypalInfo = ({
  isCompact = false,
  children = isCompact ? renderCompactInfo : renderDefaultInfo,
  ...props
}: Props) => {
  const { isRebrand } = useTheme();
  return (
    <div css={wrapperCss}>
      {!isCompact && (
        <PaymentMethodImage
          imageType={PaymentSourceType.paypal}
          isSmall={isCompact}
        />
      )}
      {children(props, isRebrand)}
    </div>
  );
};

export default PaypalInfo;
